import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth-service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isLoggedIn = authService.isAuthenticated();

  if (!isLoggedIn) {
    const urlTree = router.parseUrl(router.url);
    const routeUrl = urlTree.root.children['primary']?.segments[0]?.path;
    const path = routeUrl === 'admin' ? 'admin' : 'merchant';
    router.navigate([`${path}/login`]);
    return false;
  }

  return true;
};
